import { SRMultiStylesSchema } from './SRMulti.styles';

export const srMultiStyles: SRMultiStylesSchema = {
  multiContainer: {
    mx: '4',
    p: '2',
    bg: '#495564',
    borderRadius: 'md',
    mb: '3',
  },
  multiRunnerContainer: {
    justifyContent: 'space-between',
    bgGradient: 'linear(to-b, beta.600, beta.700)',
    p: '3',
    my: '3',
    borderRadius: 'md',
  },
  buttonLabel: {
    color: 'gray.700',
  },
  propButton: {
    w: '50px',
  },
  columnHeadings: {
    w: '50px',
    textAlign: 'center',
    fontSize: 'xs',
    color: 'gray.700',
    fontWeight: 'bold',
  },
  headingLabel: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'bold',
  },
  headingContainer: {
    textAlign: 'center',
    textTransform: 'capitalize',
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'medium',
    marginRight: '1',
  },
  runnerList: {
    borderRadius: 'md',
    bg: 'white',
    p: '2.5',
    boxShadow:
      '0px 2px 5px 0px rgba(0, 0, 0, 0.35), 0px 0px 0px 2px #000 inset',
    border: '2px',
    borderColor: '#FFE6B6',
  },
};
